import { Locale, type LocalizedString } from "./Locale.js";

export enum OrderStatus {
	Accepted = "Accepted",
	Manufactured = "Manufactured",
	ReadyForPickup = "ReadyForPickup",
	Delivered = "Delivered",
	Cancelled = "Cancelled",
}

export const orderStatusNameMap: Record<OrderStatus, LocalizedString> = {
	[OrderStatus.Accepted]: { [Locale.cs]: "Přijatá" },
	[OrderStatus.Manufactured]: { [Locale.cs]: "Vyhotovená" },
	[OrderStatus.ReadyForPickup]: { [Locale.cs]: "Připravena k vyzvednutí" },
	[OrderStatus.Delivered]: { [Locale.cs]: "Vyzvednutá" },
	[OrderStatus.Cancelled]: { [Locale.cs]: "Zrušená" },
};
